export default __webpack_public_path__ + "static/media/5b91c198224606ab4ef8c2a267af57be1577800689429.6525d396.webp";